import React from 'react';
import { ObjectTypes } from '../../../../api/consts';
import BaseSettingsPasswordSecurity from '../../AbstractObjects/BaseSettingsPasswordSecurity';

function SystemSettingsPasswordSecurity({
    systemSettingsObject,
    setSystemSettingsData
}) {    
    return (
        <BaseSettingsPasswordSecurity 
            settingsObject={systemSettingsObject}
            setSettingsData={setSystemSettingsData}
            objectType={ObjectTypes.SYSTEM_SETTINGS}
        />
    )
}

export default SystemSettingsPasswordSecurity;